import { Card, Col, Row, Select, Typography } from "antd";
import { useState } from "react";
import BarChart from "../../components/charts/apexBarChart";
import HeatMapChart from "../../components/charts/apexHeatMapChart";
import usePeakHoursGraphData from "../../hooks/usePeakHoursGraphData";
import { PEAK_HOURS_METRICS } from "../../utils/constants";

const { Text } = Typography;

const options = [
  {
    value: "occupied_time_accum",
    label: "Tempo de permanência acumulado",
  },
  {
    value: "peak_people",
    label: "Pico de pessoas",
  },
  {
    value: "occupancy_rate",
    label: "Porcentagem de ocupação",
  },
];

export default function ChartsWrapper({
  selectedDateRange,
  selectedZones,
  selectedCollections,
}) {
  const [selectedMetric, setSelectedMetric] = useState("occupied_time_accum");

  const {
    barGraphData,
    matrixGraphData,
    isLoading: loadingGraphData,
    isError: errorGraphData,
    refetch: refetchGraphData,
  } = usePeakHoursGraphData({
    start_month: selectedDateRange[0],
    end_month: selectedDateRange[1],
    zones: selectedZones,
    collections: selectedCollections,
    metric: selectedMetric,
    enable: !!selectedDateRange[0] && !!selectedDateRange[1],
  });

  const metric = PEAK_HOURS_METRICS.find(
    (metric) => metric.key === selectedMetric
  );

  return (
    <Card
      title="Gráficos de análise"
      align="center"
      style={{ width: "85%" }}
      loading={loadingGraphData}
      styles={{
        header: {
          backgroundColor: "#d0d6e2",
        },
      }}>
      <Row style={{ marginBottom: 50 }}>
        <Col span={24}>
          <Text strong style={{ marginRight: 10 }}>
            Escolha qual métrica deseja visualizar:
          </Text>

          <Select
            options={options}
            style={{
              width: "30%",
            }}
            defaultValue="occupied_time_accum"
            onChange={(value) => setSelectedMetric(value)}></Select>
        </Col>
      </Row>
      <Row>
        <Col span={12}>
          {matrixGraphData && (
            <HeatMapChart
              title="Heatmap divido por horários"
              data={matrixGraphData}
              suffix={metric?.suffix}
            />
          )}
        </Col>
        <Col span={12}>
          {barGraphData && (
            <BarChart
              title="Gráfico de barras dividido por dias"
              data={barGraphData}
              suffix={metric?.suffix}
              metric={metric?.label}
            />
          )}
        </Col>
      </Row>
    </Card>
  );
}
